export default "/assets/b0c11eaa42adffed.svg"